import { clsx } from "clsx";
import { FC, HTMLAttributes } from "react";
import classes from "./SectionDivider.module.less";

interface SectionDividerProps extends HTMLAttributes<HTMLDivElement> {}

export const SectionDivider: FC<SectionDividerProps> = ({ className, children, ...props }) => {
    return (
        <div {...props} className={clsx("sectionDivider", classes.container, className)}>
            {children}
        </div>
    );
};
